import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["onClick", "innerHTML"]

import { onMounted, ref } from 'vue';
import { FutureChange, InsurancePolicy } from '@/interfaces';
import { replaceBookmark } from '@/utils/bookmark.replace';
import { formatDate } from 'date-fns';
import {
  getPolicyStatusDetails,
  IInsurancePolicyStatusRules,
} from '@/utils/self-service-rules/InsurancePolicyStatusRules';
import { SelfServiceService } from '@/services/store';
import { LONG_MONTH_DATE } from '@/constants/formats';
enum Bookmarks {
  futureChangeEffectiveDate = 'futureChange.effectiveDate',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FutureChangesLinks',
  props: {
    insurancePolicy: {},
    item: {}
  },
  setup(__props: any) {

const policyStatusRules = ref<IInsurancePolicyStatusRules>();

const props = __props;

onMounted(async () => {
  policyStatusRules.value = await getPolicyStatusDetails(props.insurancePolicy, new Date(), false);
});

const replaceBookmarks = (futureChange: FutureChange, content: string) => {
  if (futureChange.effectiveDate) {
    content = replaceBookmark(
      Bookmarks.futureChangeEffectiveDate,
      content,
      formatDate(new Date(futureChange.effectiveDate), LONG_MONTH_DATE)
    );
  }

  //If no document replace this content.
  if (!futureChange?.documentId) {
    content = content.replace('View your', '');
  }

  return content;
};

const downloadDocument = async (documentId: string) => {
  if (!documentId) return;

  try {
    const response = await SelfServiceService.getDownloadDocument(documentId);
  } catch (error) {
    alert(`Download${documentId}${error}`);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insurancePolicy.futureChanges, (futureChange, itemIndex) => {
    return (_openBlock(), _createElementBlock("div", { key: itemIndex }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "text-racq-dark-grey text-m pr-1",
          innerHTML: replaceBookmarks(futureChange, _ctx.item?.firstLinkCompanionContent?.value)
        }, null, 8, _hoisted_2),
        _createElementVNode("span", null, [
          (futureChange?.documentId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: ($event: any) => (downloadDocument(futureChange?.documentId)),
                class: "text-base inline cursor-pointer",
                innerHTML: replaceBookmarks(futureChange, _ctx.item.firstLinkContent.value)
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ])
      ])
    ]))
  }), 128))
}
}

})